import React from 'react';
import './VisitingBCS.css';
import Background from "../assets/splash-bg.jpg";
import Footer from './Footer.tsx';

const VisitingBCS = () => {
  return (
    <div className="visiting-bcs-container">
      {/* Header Section */}
      <div 
        className="visiting-hero-section" 
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="visiting-overlay"></div>
        <div className="visiting-content">
          <div className="visiting-title-section">
            <h1 className="visiting-page-title">VISITING BCS</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Google Maps Section */}
        <div className="maps-section">
          <h2 className="section-title">GOOGLE MAPS OF DINING/HOUSING/PARKING</h2>
          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/d/u/0/embed?mid=1kznd1MXqfnqGGW4Gjg2uSSgxYjDXvXg&ehbc=2E312F&noprof=1" 
              width="640" 
              height="480"
              style={{ border: 0, width: '100%', maxWidth: '850px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>

        {/* Hotels Section */}
        <div className="content-section">
          <h2 className="section-title">HOTELS</h2>
          <p className="section-description">
            VOV will not be providing housing accommodations. We kindly ask that attendees make their 
            own arrangements for their stay. To help with planning, here are some nearby options you may consider:
          </p>
          <ul className="content-list">
            <li>Cavalry Court, Valencia Hotel Collection – 200 Century Ct, College Station, TX 77840</li>
            <li>The George, Valencia Hotel Collection – 180 Century Ct, College Station, TX 77840</li>
            <li>Hampton Inn College Station – 320 Texas Ave, College Station, TX 77840</li>
            <li>Super 8 by Wyndham College Station – 301 Texas Ave, College Station, TX 77840</li>
            <li>Embassy Suites by Hilton College Station – 201 University Dr E, College Station, TX 77840</li>
            <li>Texas A&M Hotel & Conference Center – 177 Joe Routt Blvd, College Station, TX 77840</li>
          </ul>
        </div>

        {/* Parking Section */}
        <div className="content-section">
          <h2 className="section-title">PARKING</h2>
          <p className="section-description">
            Limited parking is available at the masjid. <strong>Do not park</strong> in fire lanes, handicapped spots 
            (without a tag), the Khateeb spot on Fridays, or neighboring lots.
          </p>
          
          <h3 className="subsection-title">Nearby options:</h3>
          <ul className="content-list">
            <li><strong>College Main Garage (2 blocks):</strong> $0.50/hr, free Sundays</li>
            <li><strong>Mud Lot:</strong> $3/day</li>
            <li><strong>Street parking:</strong> $0.25/hr (6 AM–5 PM), free after 5 PM & Sundays</li>
          </ul>

          <p className="section-description">
            <strong>Texas A&M Garages</strong> (<a href="https://transport.tamu.edu/Parking/visitor.aspx" target="_blank" rel="noopener noreferrer">View here</a>): 
            Northside Garage (9 min walk) and Polo Road Garage (19 min walk) are the nearest options, but other campus garages/ surface lots are also available.
          </p>
          
          <p className="section-description">
            <strong>Fall 2025 rates:</strong> 1 hr $5 (Day) / $2.50 (Night), 2 hrs $7 / $3.50, 3 hrs $9 / $4.50, 4 hrs $11/ $5.50, +$1 / $0.50 each extra hr, max $15.
          </p>

          <p className="section-description">
            Please plan your accommodations carefully and park only in designated areas to avoid towing or citations.
          </p>
        </div>

        {/* Explore CSTAT Section */}
        <div className="content-section">
          <h2 className="section-title">EXPLORE CSTAT</h2>
          
          <div className="explore-grid">
            {/* Halal Dining Column */}
            <div className="explore-column">
              <h3 className="subsection-title">HALAL DINING</h3>
              <p className="section-description">
                For a list of halal dining options on campus and in Bryan-College Station, please view our 
                interactive map at the top of this page.
              </p>
              <p className="note-text">
                <strong>Note:</strong> Not all locations may be certified Zabiha halal. Please confirm 
                directly with each restaurant before dining.
              </p>
            </div>

            {/* Prayer Rooms Column */}
            <div className="explore-column">
              <h3 className="subsection-title">LOCATIONS OF PRAYER ROOMS ON CAMPUS</h3>
              <ul className="content-list">
                <li><strong>Sterling C. Evans Library-</strong> 5th Floor Prayer & Meditation Room</li>
                <li><strong>Zachry Engineering Education Complex-</strong> Room 300E</li>
                <li><strong>All Faiths Chapel-</strong> Prayer mats in Meditation Room 1 & 2; faucets for wudu in bathroom</li>
                <li><strong>Texas A&M College of Medicine-</strong> HPEB RM 1024; prayer mats in storage box</li>
              </ul>
            </div>
          </div>

          {/* Website Links */}
          <div className="website-links-section">
            <h3 className="links-title">LOOKING TO EXPLORE THE AREA? VISIT THESE OFFICIAL WEBSITES FOR PLACES TO VISIT!</h3>
            <div className="website-buttons">
              <a 
                href="https://visit.cstx.gov/things-to-do/?gad_source=1&gad_campaignid=22199768071&gbraid=0AAAAArEBwGMU5DhvJyVCpal0PhsYLDyqM&gclid=Cj0KCQjw_L_FBhDmARIsAItqgt4lobwtynQRufk78Er2xLvYST4UgxbIcXiNke5jPuMrfPfo8q9XefkaAvX3EALw_wcB"
                target="_blank" 
                rel="noopener noreferrer"
                className="website-button"
              >
                Visit CSTAT Website
              </a>
              <a 
                href="https://www.destinationbryan.com/things-to-do/family/?utm_source=google&utm_medium=ppc&utm_campaign=madden%20dm-txbryan&utm_content=familyfun&gad_source=1&gad_campaignid=14748484750&gbraid=0AAAAABUDuY8CSDHknd98JA6q-Y48GAiDc&gclid=Cj0KCQjw_L_FBhDmARIsAItqgt6BDmMLI4ycHijppd-RHECrexOY5yKLvidTq-JCePA3pbcdOfPQ7HUaAj_OEALw_wcB"
                target="_blank" 
                rel="noopener noreferrer"
                className="website-button"
              >
                Destination Bryan Website
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default VisitingBCS;